import { Box, Divider, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { FormattedMessage } from 'react-intl';
import {
  FieldsType,
  ILayoutFields,
  ISchemaFields,
  ISchemaForm,
  IUiFields,
  SchemaType,
} from 'modules/common/SchemaForm/utils';
import ImageBox from './ImageBox';
import MediCard from 'modules/common/component/MediCard';

const fieldSchema: ISchemaFields = ({ formProps, methods, valuesField }) => {
  const { intl, onPrint, evaluationFormMap, onSave, patientData, indicationImage, editable, enabledPrint } =
    formProps || {};
  const { setValue, trigger } = methods;

  return {
    indicationRequestId: {
      type: 'hidden',
    },
    images: {
      type: 'array',
      rawComponent: ImageBox,
      patientData: patientData,
      patientId: valuesField?.patientId,
      encounter: patientData,
      formProps,
      hideInitialElement: true,
      noHelperText: true,
      editable: editable,
      propsWrapper: { style: { paddingTop: 0, paddingBottom: 0 } },
    },
    parts: {
      type: 'auto-complete',
      options: evaluationFormMap,
      label: intl.formatMessage({ id: 'subclinical.parts' }),
      placeholder: intl.formatMessage({ id: 'subclinical.pickForm' }),
      propsWrapper: { xs: 4 },
      onChange: (value) => {
        if (value) {
          setValue('examDepartment', value?.examDepartment);
          setValue('conclusion', value?.conclusion);
        }
      },
      disableClearable: true,
      blurOnSelect: true,
      noHelperText: true,
      disabled: !editable,
    },
    examDepartment: {
      type: 'text-editor',
      label: intl.formatMessage({ id: 'subclinical.describe' }),
      height: 350,
      noHelperText: true,
    },
    conclusion: {
      type: 'text-editor',
      label: intl.formatMessage({ id: 'conclusion' }),
      height: 350,
      noHelperText: true,
      disabled: false,
    },
    content: {
      type: () => (
        <Box>
          <Typography variant={'subtitle1'}>
            <FormattedMessage id="subclinical.describe" />
          </Typography>
          <div className="mce-editor-customs" dangerouslySetInnerHTML={{ __html: indicationImage?.examDepartment }} />
          <Divider style={{ margin: '8px 0px' }} />
          <Typography variant={'subtitle1'}>
            <FormattedMessage id="conclusion" />
          </Typography>
          <div className="mce-editor-customs" dangerouslySetInnerHTML={{ __html: indicationImage?.conclusion }} />
        </Box>
      ),
    },

    submit: {
      type: 'submitButton',
      label: intl.formatMessage({ id: 'complete' }),
      style: { minWidth: 200 },
      propsWrapper: { xs: undefined },
    },
    print: onPrint && {
      type: 'button',
      label: intl.formatMessage({ id: 'imageDoctor.print' }),
      style: { minWidth: 200 },
      disabled: !enabledPrint,
      color: 'inherit',
      endIcon: <PrintIcon />,
      propsWrapper: { xs: undefined },
      onClick: onPrint,
    },
    save: {
      type: 'button',
      label: intl.formatMessage({ id: 'save' }),
      style: { minWidth: 200 },
      onClick: async () => {
        const validate = await trigger();
        if (validate) {
          onSave(valuesField);
        }
      },
      propsWrapper: { xs: undefined },
    },
  } as SchemaType;
};

const ui: IUiFields = ({ formProps }) => {
  const { editable } = formProps;
  return [
    {
      id: 'images',
      fields: ['images'],
    },
    {
      id: 'content',
      fields: editable ? ['parts', 'examDepartment', 'conclusion'] : ['content'],
    },
    {
      id: 'submit',
      fields: editable ? ['print', 'save', 'submit'] : ['print'],
      propsGridContainer: { justifyContent: 'flex-end' },
    },
  ] as FieldsType[];
};

const LayoutSchema: ILayoutFields = (props) => {
  const { listElement } = props;

  return (
    <div>
      <Box marginY={2}>{listElement[0]}</Box>
      <MediCard title="result">
        <Box margin={2}> {listElement[1]}</Box>
      </MediCard>
      <Box marginTop={2}>{listElement[2]}</Box>
    </div>
  );
};

const schemaClinical: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
  layout: LayoutSchema,
};
export default schemaClinical;
